import {typedConnect} from '../../../../commons/components/runtime-context/connect'
import {MemberPageContext} from '../types/state'

export const connect = typedConnect<MemberPageContext>()
